import * as React from 'react';

// @ts-ignore
import GroupMemberFamily from 'groups/components/GroupMemberFamily';
import getField, { Field } from '../ComposableTableField';
// @ts-ignore
import { UserProfile } from 'users/components/UsersProfile';

// use Props type from GroupMemberFamily once that's converted to typescript
type GroupMemberFamilyPropsType = {
  userId: number;
  userUuid: string;
  canAddChild: boolean;
  canAddParent: boolean;
  maxProfilePics: number;
  staticProfilePicture: boolean;
  onAddFamilyMember: () => void;
  onFamilyMemberClick: (user: UserProfile, role: string) => void;
};

export function getFamilyCellGenerator<T>(
  field: Field<T>,
  groupMemberFamilyProps: (data: T) => GroupMemberFamilyPropsType
) {
  return (data: T) => {
    const cellProps = { familySummary: getField(data, field), ...groupMemberFamilyProps(data) };
    return <GroupMemberFamily {...cellProps} />;
  };
}
